function toggleTheMenu() {
    document.querySelector(".mobile-menu").classList.toggle("mobile-menu--is-visible");
    document.querySelector("body").classList.toggle("freeze");
    return true;
}

window.onload = (event) => {
    document.querySelector(".site-header__menu-icon").addEventListener("click", () => toggleTheMenu());
    document.querySelector(".mobile-menu__close-icon").addEventListener("click", () => toggleTheMenu());
    document.querySelector(".mobile-menu li.menu-item-has-children").addEventListener("click", (event) => {
        event.preventDefault();
        console.log(event.target.classList.toggle("submenu-is-visible"));
    });
};
